/**
 * Shop Bundle Entry Point
 *
 * Loaded only on shop pages (via <script defer>) or lazy-loaded
 * when the cart icon is clicked on non-shop pages.
 */

import { init as initShop } from "./modules/shop.js";
import { init as initCart } from "./modules/cart.js";
import { init as initAvailability } from "./modules/product-availability.js";
import { init as initDiscounts } from "./modules/product-discounts.js";
import { init as initLabels } from "./modules/product-labels.js";
import { init as initCountdown } from "./modules/shop-countdown.js";
import { init as initRecentlyViewed } from "./modules/recently-viewed.js";
import { init as initAccordion } from "./modules/product-accordion.js";
import { init as initFilter } from "./modules/shop-filter.js";
import { init as initShopAnalytics } from "./modules/shop-analytics.js";
import { init as initShopSearch } from "./modules/shop-search.js";

function bootstrap() {
  initShop();
  initCart();
  initAvailability();
  initDiscounts();
  initLabels();
  initCountdown();
  initRecentlyViewed();
  initAccordion();
  initFilter();
  initShopAnalytics();
  initShopSearch();
  window.VANYX_SHOP_LOADED = true;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap);
} else {
  bootstrap();
}
